module.exports = __webpack_public_path__ + "static/media/2-e-commerce.8cd8e8e0.jpg";